import { defineComponent, openBlock, createElementBlock, createElementVNode, Fragment, renderList, toDisplayString } from "vue";
const _hoisted_1 = {
  class: "product-storytelling"
};
const _hoisted_2 = {
  class: "product-storytelling__cards-container",
  tabindex: "0"
};
const _hoisted_3 = {
  class: "product-storytelling__card--image"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "product-storytelling__card--content"
};
const _hoisted_6 = {
  class: "product-storytelling__card--lead"
};
const _hoisted_7 = {
  class: "product-storytelling__card--heading"
};
const _hoisted_8 = {
  class: "product-storytelling__card--body"
};
const _hoisted_9 = {
  class: "product-storytelling__info-container"
};
const _hoisted_10 = {
  class: "product-storytelling__info--content"
};
const _hoisted_11 = {
  class: "product-storytelling__info--lead"
};
const _hoisted_12 = {
  class: "product-storytelling__info--heading"
};
const _hoisted_13 = {
  class: "product-storytelling__info--body"
};
const _hoisted_14 = {
  class: "product-storytelling__info-image-wrapper"
};
const _hoisted_15 = {
  class: "product-storytelling__info-image"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "product-storytelling__info--image-caption"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductStorytelling",
  props: {
    cardsInfo: {},
    storytellingInfo: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.cardsInfo, (card, index) => {
        return openBlock(), createElementBlock("div", {
          key: index,
          class: "product-storytelling__card"
        }, [createElementVNode("div", _hoisted_3, [createElementVNode("img", {
          src: card.imageSrc,
          loading: "lazy",
          alt: ""
        }, null, 8, _hoisted_4)]), createElementVNode("div", _hoisted_5, [createElementVNode("div", _hoisted_6, toDisplayString(card.lead), 1), createElementVNode("div", _hoisted_7, toDisplayString(card.title), 1), createElementVNode("div", _hoisted_8, toDisplayString(card.body), 1)])]);
      }), 128))]), _cache[0] || (_cache[0] = createElementVNode("div", {
        class: "product-storytelling__horizontal-divider"
      }, null, -1)), createElementVNode("div", _hoisted_9, [createElementVNode("div", _hoisted_10, [createElementVNode("div", _hoisted_11, toDisplayString(_ctx.storytellingInfo.lead), 1), createElementVNode("div", _hoisted_12, toDisplayString(_ctx.storytellingInfo.title), 1), createElementVNode("div", _hoisted_13, toDisplayString(_ctx.storytellingInfo.body), 1)]), createElementVNode("div", _hoisted_14, [createElementVNode("div", _hoisted_15, [createElementVNode("img", {
        src: _ctx.storytellingInfo.bgImageSrc,
        loading: "lazy",
        alt: ""
      }, null, 8, _hoisted_16), createElementVNode("img", {
        class: "gif-animation",
        src: _ctx.storytellingInfo.gifSrc ? _ctx.storytellingInfo.gifSrc : _ctx.storytellingInfo.staticImageSrc,
        loading: "lazy",
        alt: ""
      }, null, 8, _hoisted_17), createElementVNode("img", {
        class: "static-image",
        src: _ctx.storytellingInfo.staticImageSrc,
        loading: "lazy",
        alt: ""
      }, null, 8, _hoisted_18)]), createElementVNode("div", _hoisted_19, toDisplayString(_ctx.storytellingInfo.caption), 1)])]), _cache[1] || (_cache[1] = createElementVNode("div", {
        class: "product-storytelling__horizontal-divider"
      }, null, -1))]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductStorytelling2.mjs.map
